module.exports = __webpack_public_path__ + "static/media/profile_pauline.00892f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/team/profile_pauline.png
// module id = 1119
// module chunks = 4